const DATE_PRESET_TODAY = { label: "Today", value: "today" };
const DATE_PRESET_YESTERDAY = { label: "Yesterday", value: "yesterday" };
const DATE_PRESET_LAST_1_HOUR = {
  label: "Last Hour",
  startDate: {
    action: "subtract",
    value: 1,
    unit: "hours",
  },
  endDate: {
    action: "subtract",
    value: 0,
    unit: "days",
  },
};
const DATE_PRESET_LAST_24_HOURS = {
  label: "Last 24 Hours",
  startDate: {
    action: "subtract",
    value: 1,
    unit: "days",
  },
  endDate: {
    action: "subtract",
    value: 0,
    unit: "days",
  },
};
const DATE_PRESET_LAST_7_DAYS = {
  label: "Last 7 days",
  startDate: {
    action: "subtract",
    value: 7,
    unit: "days",
  },
  endDate: {
    action: "subtract",
    value: 0,
    unit: "days",
  },
};
const DATE_PRESET_LAST_30_DAYS = {
  label: "Last 30 days",
  startDate: {
    action: "subtract",
    value: 30,
    unit: "days",
  },
  endDate: {
    action: "subtract",
    value: 0,
    unit: "days",
  },
};
const FILTER_DEBOUNCE = 250;
const FILTER_TYPE_DATE_RANGE = "date-range";
const FILTER_TYPE_MULTI_SELECT = "multi-select";
const FILTER_TYPE_SELECT = "select";
const FILTER_TYPE_STRING = "string";
const SENDER_INIT = "init";
const SENDER_USER = "user";
const SERIALIZED_INVERT_MATCH_KEY = "i";

export {
  DATE_PRESET_TODAY,
  DATE_PRESET_YESTERDAY,
  DATE_PRESET_LAST_1_HOUR,
  DATE_PRESET_LAST_24_HOURS,
  DATE_PRESET_LAST_7_DAYS,
  DATE_PRESET_LAST_30_DAYS,
  FILTER_DEBOUNCE,
  FILTER_TYPE_DATE_RANGE,
  FILTER_TYPE_MULTI_SELECT,
  FILTER_TYPE_SELECT,
  FILTER_TYPE_STRING,
  SENDER_INIT,
  SENDER_USER,
  SERIALIZED_INVERT_MATCH_KEY,
};
